import { Box, Stack, Typography } from '@mui/material';
import { FC } from 'react';

export const ReportLabel: FC<{ label: string }> = ({ label }) => {
  return (
    <Box sx={{ backgroundColor: 'colors.gray.o10', px: 3 }}>
      <Stack direction={'row'} alignItems={'center'} sx={{ height: '100%' }}>
        <Typography
          color="secondary"
          variant="inter20"
          fontWeight={'fontWeightBold'}
          textAlign="left"
        >
          {label}
        </Typography>
      </Stack>
    </Box>
  );
};
